/*
  tabShow 是否展示底部导航
  keepAlive 是否需要缓存组件
  noLogin 页面是否开启免登录
  
*/

import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'

import { getToken, types } from '@/utils/Token'
import { Dialog } from 'vant'
Vue.use(VueRouter)

const router = new VueRouter({
	// mode: 'history',
	routes
})

const loginUrl = '/login'

const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}

VueRouter.prototype.replace = function replace(location) {
	return originalPush.call(this, location).catch((err) => err)
}

router.beforeEach((to, from, next) => {
	if (to.meta.noLogin) {
		next()
	} else {
		if (getToken(types.Token) && getToken(types.Token) !== null) {
			next()
		} else {
			if (to.path === loginUrl) {
				next()
			} else {
				Dialog.confirm({
					title: '请先登录'
				}).then(() => {
					next('/login')
				})
			}
		}
	}
})

export default router
